import { combineReducers } from 'redux';

import { organizationStripeLoginLinkTypes } from './action_types';

import { makeRequestReducer } from '../../config/client';

const link = makeRequestReducer({
  types: organizationStripeLoginLinkTypes,
  name: 'organizationStripeLoginLink',
});

export default combineReducers({
  link,
});



// WEBPACK FOOTER //
// ./src/modules/organization/reducers.js